import {lazy, Suspense} from 'react';
import Router from '../routes/router';
import {SkeletonTheme} from 'react-loading-skeleton';
import FallbackError from '../components/fallback-error/FallbackError';
import {ErrorBoundary} from 'react-error-boundary';
import {QueryErrorResetBoundary} from '@tanstack/react-query';
import {useMixContext} from '../context/MixContext';
import {useLocation, Location} from 'react-router-dom';
//== Header and SearchBar render on every page, so splitting them buys nothing and costs a
//== serial round trip: the browser has to download and parse all of main.js before it even
//== discovers these chunks exist, which delays the first API call by ~half a second.
import Header from './header/Header';
import SearchBar from './search-bar/SearchBar';
//== Lazy Components — below the fold, genuinely worth splitting
const CookiePolicy = lazy(() => import('../components/cookie-policy/CookiePolicy'));
const AlertBox = lazy(() => import('../components/alert-box/AlertBox'));

const RootLayout = () => {
    const location: Location = useLocation();
    const {embedPath} = useMixContext();
    return (
        <SkeletonTheme
            baseColor="#171717"
            highlightColor="#1f1f1f"
            width="100%"
            height="100%"
        >
            {location?.pathname !== `/embed/${embedPath}` ? (
                <header>
                    <Header/>
                    <SearchBar/>
                </header>
            ) : null}
            <main>
                <QueryErrorResetBoundary>
                    {({reset}) => (
                        <ErrorBoundary
                            onReset={reset}
                            fallbackRender={({resetErrorBoundary}) => (
                                <FallbackError resetErrorBoundary={() => resetErrorBoundary()}/>
                            )}
                        >
                            <Router/>
                        </ErrorBoundary>
                    )}
                </QueryErrorResetBoundary>
                {location?.pathname !== `/embed/${embedPath}` ? (
                    //== These two are lazy and had no Suspense boundary above them anywhere
                    //== up to the root, which is a latent crash. fallback={null} because
                    //== both are invisible until something triggers them.
                    <Suspense fallback={null}>
                        <AlertBox/>
                        <CookiePolicy/>
                    </Suspense>
                ) : null}
            </main>
        </SkeletonTheme>
    );
};

export default RootLayout;